interface ICommitCiIndicatorProps {
  /** `success` / `failure` / `pending` / `unknown` — codegen widens this to plain `string`. */
  conclusion: string;
}

/**
 * Single-glyph CI state for one commit in the release commits table: a green
 * check, a red cross, or an amber dot while checks are still running.
 *
 * Renders nothing for `unknown`. The server reports that both for a commit
 * with no check runs and for one past its per-commit scan window, and neither
 * is a state an operator can act on — a third glyph would just add noise to a
 * column that is scanned, not read.
 */
const CommitCiIndicator = ({ conclusion }: ICommitCiIndicatorProps) => {
  if (conclusion === 'success') {
    return (
      <span className="text-fg-success-primary" title="CI passed" aria-label="CI passed">
        ✓
      </span>
    );
  }
  if (conclusion === 'failure') {
    return (
      <span className="text-fg-error-primary" title="CI failed" aria-label="CI failed">
        ✗
      </span>
    );
  }
  if (conclusion === 'pending') {
    return (
      <span
        className="bg-fg-warning-primary inline-block h-1.5 w-1.5 rounded-full align-middle"
        title="CI in progress"
        aria-label="CI in progress"
        role="img"
      />
    );
  }
  return null;
};

export default CommitCiIndicator;
